export default __webpack_public_path__ + "static/media/ken.9b952c4a.jpg";